import { Loader } from 'components'
import { LoginTypeConstObj } from 'constant/const'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
   instagramLoginAction,
   resetInstagramLoginError,
   setLoginType
} from 'store/action/AuthRedux'

function InstagramAuth() {
   const location = useLocation()
   const queryParams = new URLSearchParams(location.search)
   const dispatch = useDispatch()
   const authData = useSelector((state) => state.user)
   const { userData, loading, loginType, instagramLoginError } = authData
   const navigate = useNavigate()

   useEffect(() => {
      const myParam = queryParams.get('code')
      if (myParam) {
         dispatch(
            instagramLoginAction({
               code: myParam
            })
         )
         //  dispatch(setLoginType(LoginTypeConstObj.instagram))
      } else {
         navigate('/instagram/login')
      }
      return () => {}
   }, [])

   useEffect(() => {
      if (loginType === LoginTypeConstObj.instagram) {
         if (userData && userData?.access) {
            navigate('/instagram/dashboard')
         }
      }
      return () => {}
   }, [userData, loginType])

   useEffect(() => {
      if (instagramLoginError) {
         dispatch(resetInstagramLoginError())
         navigate('/instagram/login')
      }
      return () => {}
   }, [instagramLoginError])

   return <div>{loading && <Loader message={'Please wait while we retrieve your data...'} />}</div>
}

export default InstagramAuth
